import { useMemo } from "react";

import { AUTH_ROLES } from "api/common/types/auth.types";
import {
  useGetAllProductsQuery,
  useGetValidatorProductsQuery,
} from "api/memberPortal/project/product/product.api";
import { AppFieldType, useFieldContext } from "components/Forms/AppForm";
import { useAuth } from "hooks/useAuth";

const EcrProductSelect = () => {
  const { currentUser } = useAuth();

  const userIsValidator =
    currentUser.user_role.role_name === AUTH_ROLES.VALIDATOR;
  const { data: products, isLoading: productsLoading } = useGetAllProductsQuery(
    undefined,
    {
      skip: userIsValidator,
    },
  );
  const { data: validatorProducts, isLoading: validatorProductsLoading } =
    useGetValidatorProductsQuery(undefined, {
      skip: !userIsValidator,
    });

  const isLoading = productsLoading || validatorProductsLoading;

  const options = useMemo(() => {
    const opts = userIsValidator ? validatorProducts : products;

    if (!opts) return [];

    return opts.map((opt) => ({
      label: `${opt.v_id ? `VID ${opt.v_id} - ` : ""} ${opt.product_name} `,
      value: opt.v_id,
    }));
  }, [userIsValidator, validatorProducts, products]);

  const field = useFieldContext() as AppFieldType;

  return (
    // @ts-ignore - something weird with types going on. this does exist and renders properly
    <field.AutocompleteSelect
      loading={isLoading}
      options={options}
      // @ts-ignore - probably will be fixed when we fix the above
      onChange={(_e, value) => field.handleChange(value || "")}
      value={field.state.value || ""}
      label="Product"
      required
    />
  );
};
export default EcrProductSelect;
